import { Chapter } from '../../../../../redux/learn/type'
import { TopicInfo, Material } from '../../../../../redux/learn/type'

export const getSelectedChapter = (
  list: Array<Chapter>,
  chapterId: string
): Chapter | null => {
  const selectedChapter = list.filter(
    (chapter: Chapter) => chapter?.id === chapterId
  )
  return selectedChapter.length ? selectedChapter[0] : null
}

export const determineVideos = (topics: TopicInfo): Array<Material> => {
  const videos = topics?.materialList.filter(
    (material) => material.materialType === 'video'
  )
  return videos || []
}

export const determineSynopsis = (topics: TopicInfo): Array<Material> => {
  const synopsisList = topics?.materialList.filter(
    (material) => material.materialType === 'synopsis'
  )
  return synopsisList || []
}
